import { EPlatform } from '@enums';

let platformValue: EPlatform = null;

export const setPlatform = (platform: EPlatform) => platformValue = platform || EPlatform.UNKNOWN;

export const getPlatform = () => platformValue || EPlatform.UNKNOWN;